<!--
 * @Author: hxz
 * @Date: 2023-04-20 10:12:34
 * @LastEditors: hxz
 * @LastEditTime: 2023-04-28 11:39:35
 * @Description: 
-->
<template>
  <div>
    <img
      class="brand"
      src="https://lndxappcdn.jinlingkeji.cn/brand/guide.png"
    />
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.brand {
  width: 100%;
  height: 583vw;
}
</style>
